export interface UIState {
  spinner: boolean;
  logo: string;
}

export const initialState: UIState = {
  spinner: false,
  logo: '',
};
